import React from 'react'
import { useTranslation } from 'react-i18next';

const TopServices: React.FC<{ topServicesList: any[] }> = ({ topServicesList }) => {
    const { t } = useTranslation();

    return (
        <div className="w-full bg-white dark:bg-dark-cBackground p-6 rounded-lg shadow-md">
            <h3 className="text-[16px] font-semibold mb-4 dark:text-dark-cText">
                {t("professional.dashboard.topServices")}
            </h3>
            <div className='flex items-center justify-center h-full'>
            <h1 className='text-[22px] font-semibold text-gray-400'>Muy pronto</h1>

            </div>
            
          {/*   <table className="w-full">
                <thead>
                    <tr className="text-left">
                        <th className="py-2 dark:text-dark-cText font-medium text-[14px]">#</th>
                        <th className="py-2 dark:text-dark-cText font-medium text-[14px]">{t("professional.dashboard.serviceName")}</th>
                        <th className="py-2 dark:text-dark-cText font-medium text-[14px]">{t("professional.dashboard.popularity")}</th>
                        <th className="py-2 dark:text-dark-cText font-medium text-[14px]">{t("professional.dashboard.sales")}</th>
                    </tr>
                </thead>
                <tbody>
                    {topServicesList?.map((num, index) => (
                        <tr key={num} className="border-t">
                            <td className="dark:text-dark-cText/60 py-2 font-medium text-[14px]">{index + 1}</td>
                            <td className="dark:text-dark-cText/60 py-2 font-medium text-[14px]">Disney</td>
                            <td className="dark:text-dark-cText/60 py-2 pr-2 ">
                                <progress
                                    id="file"
                                    max="100"
                                    value={70 - (index * 10)}
                                    className="w-full h-2 appearance-none [&::-webkit-progress-bar]:rounded-full [&::-webkit-progress-bar]:bg-[#FEF2F2] [&::-webkit-progress-value]:rounded-full [&::-webkit-progress-value]:bg-[#F97068] [&::-moz-progress-bar]:rounded-full [&::-moz-progress-bar]:bg-[#F97068]"
                                ></progress>
                            </td>
                            <td className="py-2">
                                <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                                    {index + 1}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table> */}
        </div >
    )
}

export default TopServices